<template>
  <div class="card shadow">
    <div class="card-header">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'ingredients' }">Ingredients</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            Edit Ingredient
          </li>
        </ol>
      </nav>
    </div>
    <div class="card-body" v-loading="loading">
      <el-tabs v-model="activePane" @tab-click="tabChange">
        <el-tab-pane label="Details" name="details">
          <ingredient-item-detail v-if="!loading" :ingredient="ingredient" />
        </el-tab-pane>
        <el-tab-pane label="Images" name="images">
          <ingredient-item-image v-if="!loading" :ingredient="ingredient" @update="getIngredient" />
        </el-tab-pane>
        <el-tab-pane label="Preparation Steps" name="steps">
          <ingredient-item-step v-if="!loading" :ingredientId="ingredient.id" :ingredientSteps="ingredient.steps" />
        </el-tab-pane>
        <el-tab-pane label="Associated Recipes" name="related">
          <ingredient-item-association v-if="!loading" :recipes="recipes" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import IngredientItemDetail from '@/components/Ingredient/Item/IngredientItemDetail'
import IngredientItemImage from '@/components/Ingredient/Item/IngredientItemImage'
import IngredientItemStep from '@/components/Ingredient/Item/IngredientItemStep'
import IngredientItemAssociation from '@/components/Ingredient/Item/IngredientItemAssociation'

export default {
  data() {
    return {
      loading: true,
      activePane: 'details',
      ingredient: {},
      recipes: [],
    }
  },

  mounted() {
    this.getIngredient()
  },

  components: {
      IngredientItemDetail,
      IngredientItemImage,
      IngredientItemStep,
      IngredientItemAssociation,
  },

  methods: {
    tabChange(tab, event) {
      this.activePane = tab.name
    },

    async getIngredient() {
      this.loading = true

      try {
        var { data } = await this.$http.get(`/ingredients/${ this.$route.params.id }`)
      } catch(err) {
        this.$message.error(err.response.data.message)
        return false
      } finally {
        this.loading = false
      }

      this.ingredient = data.ingredient
      this.recipes = data.recipes
    },
  },
}
</script>
